import React from 'react';

import {
	NativeEmbedInitialPlaceholder,
	type NativeEmbedInitialPlaceholderProps,
} from '@atlaskit/native-embeds-common/initial-placeholder';

type NativeEmbedSsrExtension = {
	parameters?: NativeEmbedInitialPlaceholderProps['parameters'] & {
		macroMetadata?: {
			macroId?: {
				value?: string;
			};
		};
	};
};

export const NativeEmbedSsrPlaceholder = ({
	extension,
}: {
	extension?: NativeEmbedSsrExtension;
}): JSX.Element => {
	const macroId = extension?.parameters?.macroMetadata?.macroId?.value;

	return (
		<NativeEmbedInitialPlaceholder
			firstPaint
			parameters={extension?.parameters}
			placeholderId={macroId ? `native-embed-${macroId}` : undefined}
			testId="native-embed-ssr-placeholder"
		/>
	);
};
